<template>
  <div class="checkbox-wrapper" :class="[alignment, { disabled }]">
    <div class="checkbox" v-on:click="onClick" @keyup.enter="onClick" tabindex="0">
      <img :src="vPath" class="checkmark" v-if="checked">
    </div>
    <slot name="title" v-if="hasTitleSlot"></slot>
    <div v-if="label" class="checkbox-label">{{ label }}</div>
  </div>
</template>

<script>
import vPath from '../assets/icons/v-blue.svg';

export default {
  name: 'CheckBox',
  props: {
    /**
     * DEPRECATED: Use v-model instead / @input event
     */
    toggle: {
      type: Function,
      required: false,
    },
    initiallyChecked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    alignment: {
      type: String,
      default: 'center',
      validator: value => ['top', 'center'].includes(value),
    },
    label: {
      type: String,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      checked: this.initiallyChecked,
      vPath,
    };
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      if (this.toggle) {
        this.toggle();
      }
      this.checked = !this.checked;
      this.$emit('input', this.checked);
    },
  },
  computed: {
    hasTitleSlot() {
      return !!this.$slots.title;
    },
  },
  watch: {
    value(newValue) {
      this.checked = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/riseup-colors';
@import '../scss/spacings';

.checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  width: 100%;

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    .checkbox {
      cursor: not-allowed;
    }
  }

  &.top {
    align-items: flex-start;
    .checkbox {
      margin-top: $ri-spacing-xxs;
    }
  }

  .checkbox-label {
    margin-right: $ri-spacing-xs;
  }

  .checkbox {
    height: 25px;
    width: 25px;
    min-width: 25px;
    min-height: 25px;
    border-radius: 4px;
    border: solid 1px #979797;
    cursor: pointer;
    .checkmark {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
